import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";
import CopyIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CopyIconPath";

interface CopyToClipboardButtonProps {
  valueForClipboard: string;
  onClick: () => void;
}

export const CopyToClipboardButton = ({
  valueForClipboard,
  onClick,
}: CopyToClipboardButtonProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();

  return (
    <FixaButton
      ssrIcon={CopyIconPath}
      onClick={() => {
        onClick();
        navigator.clipboard.writeText(valueForClipboard);
        showToast(t("artileNumberCopiedToCliboardString"));
      }}
      iconOnly
      type="tertiary"
      data-testid={`copyToClipboardButton-${valueForClipboard}`}
      size="xsmall"
    />
  );
};
